/*@flow*/
import flash from 'lib/flash';

type LatLon = [number, number];
export default (): Promise<LatLon> => {
  if (navigator.geolocation) {
    return new Promise((res, rej) => {
      const opts = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };
      return navigator.geolocation.getCurrentPosition(res, rej, opts);
    })
      .then(position => {
        const { latitude: lat, longitude: lng } = position.coords;
        return Promise.resolve([lat, lng]);
      })
      .catch(e => {
        flash('Unable to find your location.');
        return Promise.reject(e);
      });
  }
    const msg = 'Geolocation not supported by your system.';
    flash(msg);
    return Promise.reject(msg);
};
